/* SpawnAnything — save a file (download) or hand it to the system share sheet (Web Share API, mostly mobile). */

export function downloadBlob(blob, name) {
  const url = URL.createObjectURL(blob), a = document.createElement('a');
  a.href = url; a.download = name; a.rel = 'noopener'; a.style.display = 'none';
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30000);
}

export function canShareFile(file) {
  try { return !!(navigator.canShare && navigator.share && navigator.canShare({ files: [file] })); } catch (e) { return false; }
}

/** true = shared, false = the user cancelled; throws on other errors */
export async function shareFile(file, title, text) {
  try { await navigator.share({ files: [file], title, text }); return true; }
  catch (e) { if (e && e.name === 'AbortError') return false; throw e; }
}

export const fmtBytes = n => n >= 1048576 ? (n / 1048576).toFixed(1).replace('.', ',') + ' MB' : Math.max(1, Math.round(n / 1024)) + ' KB';
